import styled, { css } from 'styled-components';

const NavBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  transform: rotate(-90deg);
  transform-origin: top left;
  height: 4.625rem;
  margin-bottom: -3.25rem;
  z-index: 13;

  > * {
    margin: 0 0.593rem;
  }

  > a:first-child {
    margin-bottom: -0.7rem;
    margin-right: 1.125rem;
  }

  @media screen and (max-width: 64rem) {
    display: none;
  }

  ${props =>
    props.primary &&
    css`
      bottom: 0;

      @media all and (max-height: 34rem) {
        display: none;
      }
    `};

  ${props =>
    props.secondary &&
    css`
      top: 12rem;
      transform-origin: bottom left;
      transform: rotate(90deg);
      flex-direction: row-reverse;
      margin-bottom: 0;
      margin-top: -3.25rem;

      > * {
        transform: rotate(180deg);
      }

      @media all and (max-height: 60rem) {
        display: none;
      }
    `};
`;

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar.js